import React, { createContext } from 'react';

export const ServiciosContext = createContext();